import { render, staticRenderFns } from "./FormDependents.vue?vue&type=template&id=7c8bcc6a"
import script from "./FormDependents.vue?vue&type=script&lang=js"
export * from "./FormDependents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports